import { QueryCache, QueryClient } from "@tanstack/react-query";
import { queryCacheOnErrorHandler, defaultQueryClientRetryHandler } from "./utils";

// Singleton QueryClient, extracted out of App.tsx so it can be imported
// wherever a session needs to be torn down (e.g. useCrossTabAuthSync)
// without reaching into App's module scope.
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: queryCacheOnErrorHandler,
  }),
  defaultOptions: {
    queries: {
      retry: defaultQueryClientRetryHandler,
      staleTime: 1000 * 60,
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});
